import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const ToggleCollectionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ToggleCollection"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idTag"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"toggleOff"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"toggleTag"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"idBoard"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idBoard"}}},{"kind":"Argument","name":{"kind":"Name","value":"idTag"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idTag"}}},{"kind":"Argument","name":{"kind":"Name","value":"toggleOff"},"value":{"kind":"Variable","name":{"kind":"Name","value":"toggleOff"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idTags"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"ToggleCollection","document":ToggleCollectionDocument}} as const;
export type ToggleCollectionMutationVariables = Types.Exact<{
  idBoard: Types.Scalars['ID']['input'];
  idTag: Types.Scalars['ID']['input'];
  toggleOff: Types.Scalars['Boolean']['input'];
  traceId: Types.Scalars['ID']['input'];
}>;


export type ToggleCollectionMutation = (
  { __typename: 'Mutation' }
  & { toggleTag?: Types.Maybe<(
    { __typename: 'Board' }
    & Pick<Types.Board, 'id' | 'idTags' | 'name'>
  )> }
);

export type ToggleCollectionMutationFn = Apollo.MutationFunction<
  ToggleCollectionMutation,
  ToggleCollectionMutationVariables
>;

/**
 * __useToggleCollectionMutation__
 *
 * To run a mutation, you first call `useToggleCollectionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleCollectionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleCollectionMutation, { data, loading, error }] = useToggleCollectionMutation({
 *   variables: {
 *      idBoard: // value for 'idBoard'
 *      idTag: // value for 'idTag'
 *      toggleOff: // value for 'toggleOff'
 *      traceId: // value for 'traceId'
 *   },
 * });
 */
export function useToggleCollectionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ToggleCollectionMutation,
    ToggleCollectionMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ToggleCollectionMutation,
    ToggleCollectionMutationVariables
  >(ToggleCollectionDocument, options);
}
export type ToggleCollectionMutationHookResult = ReturnType<
  typeof useToggleCollectionMutation
>;
export type ToggleCollectionMutationResult =
  Apollo.MutationResult<ToggleCollectionMutation>;
export type ToggleCollectionMutationOptions = Apollo.BaseMutationOptions<
  ToggleCollectionMutation,
  ToggleCollectionMutationVariables
>;
